import React from 'react';
import styles from './index.module.scss';
import { motion } from 'framer-motion';

import PopUp from './../../../pop-up/index';
import PopUpPosition from '../../../pop-up/pop-up-position';
import CategoryList from '../category-list';
import usePopup from './../../../../hooks/usePopup';
import { FlattenedProductProps } from '../../../../models';

import RightArrowSmSvg from './../../../svgs/RightArrowSmSvg';

type CategoriesBarProps = {
	setCategory: (arg: string) => void;
	category: string | null;
	setSearchValue: (arg: string) => void;
	productData: FlattenedProductProps[];
};

const CatergoriesBar = ({ productData, category, setCategory, setSearchValue }: CategoriesBarProps) => {
	const ref = React.useRef<HTMLDivElement>(null);

	const { x, y, show, setShow } = usePopup({ ref, marginY: 490 });

	return (
		<>
			<PopUp {...{ show, setShow }}>
				<PopUpPosition
					{...{
						x,
						y,
						width: '350px',
						styleClass: `${styles.shadow} ${styles.rounded}`,
						setShow,
					}}
				>
					<CategoryList {...{ setShow, data: productData, category, setCategory, setSearchValue }} />
				</PopUpPosition>
			</PopUp>

			<div
				onClick={() => setShow(!show)}
				ref={ref}
				className={`${styles.wrapper} mt-4 d-flex justify-between align-items-center flex-fill p-2`}
			>
				<div className="d-flex align-items-center">
					<div className={`${styles.categories} `}>
						<span>Categories</span>
					</div>
					<motion.div
						className={`${styles.w} mx-4 p-1`}
						animate={{
							translateX: '1px',
							scale: 1.5,
							opacity: 0.5,
							transition: {
								repeat: Infinity,
								duration: 5,
								delay: 3,
								ease: 'easeInOut',
							},
						}}
					>
						<RightArrowSmSvg />
					</motion.div>
					<div className={`capitalize ${styles.category}`}>{category}</div>
				</div>
				<div>
					<button
						className={`${styles.clearButton} pl-2 text-[1em] font-normal`}
						onClick={() => {
							setCategory('');
						}}
					>
						Clear
					</button>
				</div>
			</div>
		</>
	);
};

export default CatergoriesBar;
